import './index.scss'
$(".product-nav li a").click(function() {
    $(".product-nav li").removeClass("active");
    $(this).parent().addClass('active');
    let id = $(this).attr("href").split("#").pop()
    var top = $('#' + id).offset().top;
    console.log(top);
    $('html,body').animate({
        scrollTop: top - 120
    }, 500);
})